import React from 'react';

import PropTypes from 'prop-types';

const CarouselArrowIcon = ({ width = 10, height = 16, color = '#1B1C19' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 10 16"
      fill="none"
    >
      <path
        d="M0.244186 14.7578C0.16677 14.8254 0.105361 14.9056 0.0634632 14.9939C0.0215654 15.0822 0 15.1768 0 15.2724C0 15.3679 0.0215654 15.4625 0.0634632 15.5508C0.105361 15.6391 0.16677 15.7193 0.244186 15.7869C0.321603 15.8544 0.41351 15.908 0.51466 15.9446C0.615809 15.9812 0.72422 16 0.833704 16C0.943188 16 1.0516 15.9812 1.15275 15.9446C1.2539 15.908 1.34581 15.8544 1.42322 15.7869L9.75562 8.51452C9.83309 8.44698 9.89455 8.36677 9.93648 8.27849C9.97842 8.1902 10 8.09557 10 8C10 7.90443 9.97842 7.8098 9.93648 7.72151C9.89455 7.63323 9.83309 7.55302 9.75562 7.48548L1.42322 0.213121C1.26687 0.0766618 1.05482 -3.80414e-09 0.833704 0C0.612592 3.80414e-09 0.400537 0.0766618 0.244186 0.213121C0.0878363 0.34958 0 0.534658 0 0.72764C0 0.920622 0.0878363 1.1057 0.244186 1.24216L7.98811 8L0.244186 14.7578Z"
        fill={color}
      />
    </svg>
  );
};

CarouselArrowIcon.propTypes = {
  color: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
};

export default CarouselArrowIcon;
